import { FileText, Link, HardHat } from "lucide-react";
import type { ResourceType } from "../types";
import { RESOURCE_TYPE_LABELS } from "../types";

const CONFIG: Record<ResourceType, { icon: React.ReactNode; className: string }> = {
  document: {
    icon: <FileText size={11} />,
    className: "bg-blue-50 text-[var(--color-primary)] dark:bg-blue-900/30 dark:text-blue-300",
  },
  link: {
    icon: <Link size={11} />,
    className: "bg-violet-50 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300",
  },
  contractor_document: {
    icon: <HardHat size={11} />,
    className: "bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
  },
};

export function ResourceTypeBadge({ type }: { type: ResourceType }) {
  const { icon, className } = CONFIG[type];
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${className}`}>
      {icon}
      {RESOURCE_TYPE_LABELS[type]}
    </span>
  );
}
